/**
 * Created by 马荣钦 on 2016/2/2.
 */
"use strict";
angular.module('editOutSendingModule', ['editOutSendingAddModule', 'editOutSendingDelModule'])
    .controller("editOutSendingCtrl", ["$scope", "$modalInstance", "$modal", "trsHttpService", "modalDialog", "params", "trsspliceString", function($scope, $modalInstance, $modal, trsHttpService, modalDialog, params, trsspliceString) {
        initStatus();
        initData();

        function initStatus() {
            $scope.isEdit = false;
            $scope.deleteEmailArray = [];
            $scope.selectedArray = [];
            $scope.params = {
                serviceid: "mlf_maillist",
                methodname: "queryMailLists"
            }
        }

        function initData() {
            requestData();

        }

        function requestData() {
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, "get").then(function(data) {
                $scope.emailList = data;
                $scope.selectedArray = [];
                $scope.deleteEmailArray = [];
            });
        }
        //增加通讯人
        $scope.addNewEmail = function() {
            addNewEmail("", function(result) {
                var params = {
                    serviceid: "mlf_maillist",
                    methodname: "saveMailList",
                    Email: result.email,
                    EmailDesc: result.emailDesc
                };
                if (params.EmailDesc == "") {
                    delete params.EmailDesc;
                }
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                    requestData();
                });
            });
        };
        //增加通讯人方法
        function addNewEmail(transData, successFn) {
            var modalInstance = $modal.open({
                templateUrl: "./editingCenter/service/outSending/addEmail/addEmail.html",
                windowClass: 'edit-outSending-add-window',
                backdrop: false,
                controller: "editOutSendingAddCtrl",
                resolve: {
                    params: function() {
                        return transData
                    }
                }
            });
            modalInstance.result.then(function(result) {
                successFn(result)
            });
        }

        //修改单个通讯人信息
        $scope.editSingleEmail = function(item) {
            editSingleEmail(item, function(result) {
                var params = {
                    serviceid: "mlf_maillist",
                    methodname: "editMailList",
                    mailListId :item.MAILLISTID,
                    newEmail : result.email,
                    newEmailDesc : result.emailDesc
                };
                if (params.newEmailDesc == "") {
                    delete params.newEmailDesc;
                }
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                    requestData();
                });
            });
        };

         //修改单个通讯人方法
        function editSingleEmail(transData, successFn) {
            var modalInstance = $modal.open({
                templateUrl: "./editingCenter/service/outSending/addEmail/addEmail.html",
                windowClass: 'edit-outSending-add-window',
                backdrop: false,
                controller: "editOutSendingAddCtrl",
                resolve: {
                    params: function() {
                        return transData
                    }
                }
            });
            modalInstance.result.then(function(result) {
                successFn(result)
            });
        }


        //编辑通讯人信息
        $scope.editEmail = function() {
            isEditing();
            // var item = $scope.selectedArray[0];
            // addNewEmail(item, function(result) {
            //     var params = {
            //         serviceid: "mlf_maillist",
            //         methodname: "editMailList",
            //         mailListId: item.MAILLISTID,
            //         newEmail: result.email,
            //         newEmailDesc: result.emailDesc
            //     };
            //     $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
            //         if(data.ISSUCCESS){
            //             requestData();
            //         };
            //     });
            // });
        }
        //删除通讯人的叉叉
        $scope.deleteEmail = function(item) {
            // var ind=$scope.emailList.indexOf(item);
            // var name=$scope.emailList[ind].EMAILDESC;
            deleteConfirm(item, function(sta) {
                var ids = sta.MAILLISTID;
                var params = {
                    serviceid: "mlf_maillist",
                    methodname: "deleteMailList",
                    MailListIds: ids
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                    requestData();
                    $scope.deleteEmailArray = [];
                });
            });
        };

        //确认删除通讯人
        function deleteConfirm(item, success) {
            var modalInstance = $modal.open({
                templateUrl: "./editingCenter/service/outSending/deleteEmail/deleteEmail.html",
                windowClass: 'edit-outSending-del-window',
                backdrop: false,
                controller: "editOutSendingDelCtrl",
                resolve: {
                    params: function() {
                        return item;
                    }
                }
            });
            modalInstance.result.then(function(result) {
                success(result)
            });
        };


        //单选
        $scope.selectDoc = function(item) {
            if ($scope.selectedArray.indexOf(item) < 0) {
                $scope.selectedArray.push(item);
            } else {
                $scope.selectedArray.splice($scope.selectedArray.indexOf(item), 1);
            }

        };
        //关闭窗口
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };
        $scope.outSendingConfirm = function() {
            if ($scope.selectedArray.length > 0) {
                $modalInstance.close({
                    selectItems: $scope.selectedArray
                });
                // modalDialog.confirmModal("外发稿件", "您确认外发？", function() {
                //     $modalInstance.close({
                //         selectItems: $scope.selectedArray
                //     });
                // });
            } else {
                modalDialog.alertType("", "请选择发送对象", "info", 'confirm');
            }
        };
        //编辑非编辑模式切换
        function isEditing() {
            $scope.isEdit = !$scope.isEdit;
            $scope.selectedArray.splice(0, $scope.selectedArray.length);
        };
        $scope.editComplate = function() {
            isEditing();
        }
    }]);